"use strict";
// Third-Party Provider System Contracts
// Generated from Prisma schema for GlonexTrack telematic services
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutStatus = exports.DocumentVerificationStatus = exports.ProviderDocumentType = exports.ServiceRequestStatus = exports.ServicePriority = exports.ServiceRequestType = exports.RevenueShareModel = exports.KYCStatus = exports.OnboardingStage = exports.ProviderStatus = exports.ServiceProviderType = void 0;
var ServiceProviderType;
(function (ServiceProviderType) {
    ServiceProviderType["SECURITY_AGENCY"] = "SECURITY_AGENCY";
    ServiceProviderType["MECHANIC_SHOP"] = "MECHANIC_SHOP";
    ServiceProviderType["TOW_TRUCK_COMPANY"] = "TOW_TRUCK_COMPANY";
    ServiceProviderType["AMBULANCE_SERVICE"] = "AMBULANCE_SERVICE";
    ServiceProviderType["FIRE_BRIGADE"] = "FIRE_BRIGADE";
    ServiceProviderType["ROADSIDE_ASSISTANCE"] = "ROADSIDE_ASSISTANCE";
    ServiceProviderType["VEHICLE_RECOVERY"] = "VEHICLE_RECOVERY";
    ServiceProviderType["GPS_INSTALLATION"] = "GPS_INSTALLATION";
    ServiceProviderType["DEVICE_MAINTENANCE"] = "DEVICE_MAINTENANCE";
    ServiceProviderType["EMERGENCY_DISPATCH"] = "EMERGENCY_DISPATCH";
    ServiceProviderType["INSURANCE_ASSESSOR"] = "INSURANCE_ASSESSOR";
    ServiceProviderType["FLEET_CONSULTANT"] = "FLEET_CONSULTANT";
    ServiceProviderType["OTHER"] = "OTHER";
})(ServiceProviderType || (exports.ServiceProviderType = ServiceProviderType = {}));
var ProviderStatus;
(function (ProviderStatus) {
    ProviderStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    ProviderStatus["ACTIVE"] = "ACTIVE";
    ProviderStatus["SUSPENDED"] = "SUSPENDED";
    ProviderStatus["INACTIVE"] = "INACTIVE";
    ProviderStatus["REJECTED"] = "REJECTED";
    ProviderStatus["BLACKLISTED"] = "BLACKLISTED";
})(ProviderStatus || (exports.ProviderStatus = ProviderStatus = {}));
var OnboardingStage;
(function (OnboardingStage) {
    OnboardingStage["DOCUMENTATION"] = "DOCUMENTATION";
    OnboardingStage["KYC_VERIFICATION"] = "KYC_VERIFICATION";
    OnboardingStage["COMPLIANCE_CHECK"] = "COMPLIANCE_CHECK";
    OnboardingStage["PERFORMANCE_TRIAL"] = "PERFORMANCE_TRIAL";
    OnboardingStage["APPROVED"] = "APPROVED";
    OnboardingStage["REJECTED"] = "REJECTED";
})(OnboardingStage || (exports.OnboardingStage = OnboardingStage = {}));
var KYCStatus;
(function (KYCStatus) {
    KYCStatus["PENDING"] = "PENDING";
    KYCStatus["IN_REVIEW"] = "IN_REVIEW";
    KYCStatus["APPROVED"] = "APPROVED";
    KYCStatus["REJECTED"] = "REJECTED";
    KYCStatus["REQUIRES_UPDATE"] = "REQUIRES_UPDATE";
})(KYCStatus || (exports.KYCStatus = KYCStatus = {}));
var RevenueShareModel;
(function (RevenueShareModel) {
    RevenueShareModel["PERCENTAGE"] = "PERCENTAGE";
    RevenueShareModel["FLAT_FEE"] = "FLAT_FEE";
    RevenueShareModel["TIERED"] = "TIERED";
    RevenueShareModel["CUSTOM"] = "CUSTOM";
})(RevenueShareModel || (exports.RevenueShareModel = RevenueShareModel = {}));
var ServiceRequestType;
(function (ServiceRequestType) {
    ServiceRequestType["EMERGENCY_DISPATCH"] = "EMERGENCY_DISPATCH";
    ServiceRequestType["SECURITY_RESPONSE"] = "SECURITY_RESPONSE";
    ServiceRequestType["VEHICLE_BREAKDOWN"] = "VEHICLE_BREAKDOWN";
    ServiceRequestType["ACCIDENT_RECOVERY"] = "ACCIDENT_RECOVERY";
    ServiceRequestType["GPS_INSTALLATION"] = "GPS_INSTALLATION";
    ServiceRequestType["DEVICE_REPAIR"] = "DEVICE_REPAIR";
    ServiceRequestType["ROUTINE_MAINTENANCE"] = "ROUTINE_MAINTENANCE";
    ServiceRequestType["CONSULTATION"] = "CONSULTATION";
    ServiceRequestType["ASSESSMENT"] = "ASSESSMENT";
    ServiceRequestType["OTHER"] = "OTHER";
})(ServiceRequestType || (exports.ServiceRequestType = ServiceRequestType = {}));
var ServicePriority;
(function (ServicePriority) {
    ServicePriority["EMERGENCY"] = "EMERGENCY";
    ServicePriority["HIGH"] = "HIGH";
    ServicePriority["STANDARD"] = "STANDARD";
    ServicePriority["LOW"] = "LOW";
})(ServicePriority || (exports.ServicePriority = ServicePriority = {}));
var ServiceRequestStatus;
(function (ServiceRequestStatus) {
    ServiceRequestStatus["PENDING"] = "PENDING";
    ServiceRequestStatus["ASSIGNED"] = "ASSIGNED";
    ServiceRequestStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ServiceRequestStatus["COMPLETED"] = "COMPLETED";
    ServiceRequestStatus["CANCELED"] = "CANCELED";
    ServiceRequestStatus["FAILED"] = "FAILED";
})(ServiceRequestStatus || (exports.ServiceRequestStatus = ServiceRequestStatus = {}));
var ProviderDocumentType;
(function (ProviderDocumentType) {
    ProviderDocumentType["BUSINESS_LICENSE"] = "BUSINESS_LICENSE";
    ProviderDocumentType["TAX_CERTIFICATE"] = "TAX_CERTIFICATE";
    ProviderDocumentType["INSURANCE_POLICY"] = "INSURANCE_POLICY";
    ProviderDocumentType["PROFESSIONAL_CERTIFICATION"] = "PROFESSIONAL_CERTIFICATION";
    ProviderDocumentType["IDENTITY_DOCUMENT"] = "IDENTITY_DOCUMENT";
    ProviderDocumentType["BANK_STATEMENT"] = "BANK_STATEMENT";
    ProviderDocumentType["PROOF_OF_ADDRESS"] = "PROOF_OF_ADDRESS";
    ProviderDocumentType["SERVICE_AGREEMENT"] = "SERVICE_AGREEMENT";
    ProviderDocumentType["COMPLIANCE_CERTIFICATE"] = "COMPLIANCE_CERTIFICATE";
    ProviderDocumentType["OTHER"] = "OTHER";
})(ProviderDocumentType || (exports.ProviderDocumentType = ProviderDocumentType = {}));
var DocumentVerificationStatus;
(function (DocumentVerificationStatus) {
    DocumentVerificationStatus["PENDING"] = "PENDING";
    DocumentVerificationStatus["VERIFIED"] = "VERIFIED";
    DocumentVerificationStatus["REJECTED"] = "REJECTED";
    DocumentVerificationStatus["EXPIRED"] = "EXPIRED";
    DocumentVerificationStatus["REQUIRES_UPDATE"] = "REQUIRES_UPDATE";
})(DocumentVerificationStatus || (exports.DocumentVerificationStatus = DocumentVerificationStatus = {}));
var PayoutStatus;
(function (PayoutStatus) {
    PayoutStatus["PENDING"] = "PENDING";
    PayoutStatus["PROCESSING"] = "PROCESSING";
    PayoutStatus["COMPLETED"] = "COMPLETED";
    PayoutStatus["FAILED"] = "FAILED";
    PayoutStatus["CANCELED"] = "CANCELED";
})(PayoutStatus || (exports.PayoutStatus = PayoutStatus = {}));
// All types are already exported via their individual declarations above
